var EHDI = EHDI || Object.create(null);

EHDI.GetGlobalPool = function () {
  if (EHDI.GlobalPool == undefined)
  {
    EHDI.GlobalPool = {};
    // EHDI.GlobalPool.containerPool = new EHDI.PoolManager(EHDI.aka.Container);
    EHDI.GlobalPool.gameScenePool = new EHDI.PoolManager(EHDI.scene.GameScene);
    // EHDI.GlobalPool.platformPool = new EHDI.PoolManager(EHDI.game.Platform);
    // EHDI.GlobalPool.spritePool = new EHDI.PoolManager(EHDI.aka.Sprite);
    // EHDI.GlobalPool.animationPool = new EHDI.PoolManager(EHDI.game.Animation);
    // EHDI.GlobalPool.animalPool = new EHDI.PoolManager(EHDI.game.Animal);
    // EHDI.GlobalPool.leafPool = new EHDI.PoolManager(EHDI.game.Effect);
    // EHDI.GlobalPool.tapPool = new EHDI.PoolManager(EHDI.game.Effect);
    // EHDI.GlobalPool.warningPool = new EHDI.PoolManager(EHDI.game.Warning);
    // EHDI.GlobalPool.glowPool = new EHDI.PoolManager(EHDI.game.Glow);
  }

  return EHDI.GlobalPool;
};

EHDI.PoolManager = function (objtype) {
    this._objType = objtype;
    this._totalObjects;
    this._inactiveObjexts;

    this._objPool;

    this.init();
  };

EHDI.PoolManager.prototype.init = function () {
    this._totalObjects = 0;
    this._inactiveObjexts = 0;

    this._objPool = [];
  };

EHDI.PoolManager.prototype.freeUp = function () {
    this._totalObjects = this._totalObjects - this._inactiveObjexts;
    this._inactiveObjexts = 0;

    this._objPool = [];
  };

EHDI.PoolManager.prototype.get = function () {
    var obj;

    // if (this._objPool.length == 0) {
      obj = new this._objType;
    //
    //   this._totalObjects++;
    // } else {
    //   obj = this._objPool.pop();
    //
    //   this._inactiveObjexts--;
    // }

    return obj;
  };

EHDI.PoolManager.prototype.return = function (obj) {
  if (typeof(obj.reset) == 'function')
    obj.reset();

  this._objPool.push(obj);

  this._inactiveObjexts++;
};
